import { computed } from 'vue';
import { pathOr } from 'ramda';
import useCallEndPointWith from '@/services/backend/useCallEndPointWith';

const useCalculatePrice = () => {
  const {
    endpointData, callEndpoint, userFriendlyError, isLoading,
  } = useCallEndPointWith('calculatePrice');

  const fetch = async (planId, numberOfSeats, redeemKey) => {
    isLoading.value = true;
    await callEndpoint({
      method: 'POST',
      request: {
        planId,
        numberOfSeats,
        redeemKey,
      },
    });
  };

  const response = computed(() => ({
    total: pathOr('', ['pricing', 'total'], endpointData.value),
    vat: pathOr('', ['pricing', 'vat'], endpointData.value),
  }));

  return {
    fetch, response, isLoading, userFriendlyError,
  };
};

export default useCalculatePrice;
